<template>
  <div class="error-page">
    <div class="error-container">
      <!-- 404 数字动画 -->
      <h1 class="error-code">404</h1>
      <h2 class="error-title">页面不存在</h2>
      <p class="error-desc">抱歉，您访问的页面已丢失或不存在</p>

      <!-- 返回按钮 -->
      <button class="back-btn" @click="goBack">返回首页</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  methods: {
    goBack() {
      this.$router.push("/");
    },
  },
};
</script>

<style scoped lang="less">
.error-page {
  width: 100vw;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #e4eaf5 100%);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica,
    Arial, sans-serif;
}

.error-container {
  text-align: center;
  padding: 60px 40px;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.08);
  animation: fadeIn 0.6s ease forwards;
}

// 404 大号数字
.error-code {
  font-size: 90px;
  font-weight: 900;
  color: #409eff;
  margin: 0;
  line-height: 1;
  animation: bounce 1.2s ease infinite alternate;
}

.error-title {
  font-size: 28px;
  color: #333;
  margin: 16px 0 8px;
  font-weight: 600;
}

.error-desc {
  font-size: 16px;
  color: #777;
  margin-bottom: 32px;
}

// 返回按钮
.back-btn {
  padding: 12px 30px;
  border: none;
  border-radius: 50px;
  background: #409eff;
  color: white;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);

  &:hover {
    transform: translateY(-2px);
    background: #337ecc;
    box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
  }
}

// 动画
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes bounce {
  from {
    transform: scale(1);
  }
  to {
    transform: scale(1.05);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/error/index.vue